export const openSnackbar = ({message, type}) => ({
  type: 'OPEN_SNACKBAR',
  message,
  loader:false,
  msgType: type,
});

export const closeSnackBar = () => ({
  type: 'CLOSE_SNACKBAR',
});
